export const teamNamePlaceholder = "Name your team";

export const teamNumberPlaceholder = "Number of members (minimum 2)";
